import Popup from './plugins/popup';

let myPopup;

const getPress= async e => {
  e.preventDefault();
  e.stopImmediatePropagation();
  const idAttr = e.currentTarget.getAttribute('id');
  const id = idAttr.split('-')[1] || 0;

  const form = new FormData();
  form.append("action", "getpress");
  form.append("id",id );
  const body = new URLSearchParams(form);

  const response = await fetch(loadmore_params.ajaxurl, {
    // you can also use $.post here
    method: "POST",
    credentials: "same-origin",
    headers: new Headers({ "Content-Type": "application/x-www-form-urlencoded" }),
    body: body
    // headers: {
    //   'Content-Type': 'application/json;charset=utf-8'
    // },
    // body: body
  });

  const result = await response.text();

  if (response.status === 200) {
   
    myPopup.open('<div class="suki-wrapper">'+result+'</div>');
  }
};

export const cleanGetPress = () => {
  const openPressLinks = document.querySelectorAll(".post-type-archive-press #loop article");
  openPressLinks.forEach(openPressLink => {
    openPressLink.removeEventListener("click", getPress);
  });
};

export const initGetPress = () => {
  initPopup();
  const openPressLinks = document.querySelectorAll(".post-type-archive-press #loop article");

  openPressLinks.forEach(openPressLink => {
    openPressLink.addEventListener("click", getPress);
  });
};




const initPopup = () => {

   myPopup = new Popup('popup-press');
 
};


